(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-tab-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const tabStates = new Map();
  
  function initTabState(tabIndex) {
    if (!tabStates.has(tabIndex)) {
      tabStates.set(tabIndex, {
        currentPage: 1,
        currentYear: 'all',
        posts: []
      });
    }
  }

  function scrollToTop() {
    const blogSection = document.querySelector('.blog-tab-section');
    if (blogSection) {
      blogSection.scrollIntoView({ behavior: 'smooth' });
    }
  }

  // --- 新增的功能：動態對齊同一列的標題高度 ---
  function alignPostTitles(visiblePosts) {
    // 1. 先重置所有標題的高度，抓取自然高度
    visiblePosts.forEach(post => {
      const title = post.querySelector('.blog-post-title');
      if(title) title.style.minHeight = 'auto';
    });

    // 2. 如果是手機版（單欄），不需要對齊，直接結束
    if (window.innerWidth <= 768) return;

    // 3. 兩兩一組進行比較 (Grid 是 2 columns)
    for (let i = 0; i < visiblePosts.length; i += 2) {
      const postA = visiblePosts[i];
      const postB = visiblePosts[i + 1];

      if (postA && postB) {
        const titleA = postA.querySelector('.blog-post-title');
        const titleB = postB.querySelector('.blog-post-title');
        
        if (titleA && titleB) {
          // 取得兩者中較高的高度
          const heightA = titleA.offsetHeight;
          const heightB = titleB.offsetHeight;
          const maxHeight = Math.max(heightA, heightB);

          // 將該高度應用到兩個標題上
          titleA.style.minHeight = maxHeight + 'px';
          titleB.style.minHeight = maxHeight + 'px';
        }
      }
    }
  }
  // ------------------------------------------

  function showTabByHash() {
    const hash = window.location.hash.replace('#', '');
    if (hash) {
      const targetTab = document.querySelector(`.blog-tab[data-tab-id="${hash}"]`);
      if (targetTab) {
        const tabIndex = parseInt(targetTab.dataset.tab);
        activateTab(tabIndex - 1);
      }
    }
  }

  function activateTab(tabIndex) {
    const tabs = document.querySelectorAll('.blog-tab');
    const contents = document.querySelectorAll('.blog-content');
    
    tabs.forEach(t => t.classList.remove('active'));
    contents.forEach(content => content.style.display = 'none');
    
    if (tabs[tabIndex] && contents[tabIndex]) {
      tabs[tabIndex].classList.add('active');
      contents[tabIndex].style.display = 'flex';
      
      const postContainer = contents[tabIndex].querySelector('.blog-posts');
      setupPagination(postContainer, tabIndex + 1);
      
      // 這裡不需要 scrollToTop，因為初始化時不需要跳轉
    }
  }

  function updateUrlHash(tabId) {
    if (history.pushState) {
      const newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + '#' + tabId;
      window.history.pushState({path: newUrl}, '', newUrl);
    } else {
      window.location.hash = tabId;
    }
  }

  function setupPagination(postContainer, tabIndex) {
    initTabState(tabIndex);
    const state = tabStates.get(tabIndex);
    
    const allPosts = Array.from(postContainer.querySelectorAll('.blog-post'));
    const paginationContainer = postContainer.querySelector('.blog-pagination');
    const prevButton = paginationContainer.querySelector('.prev');
    const nextButton = paginationContainer.querySelector('.next');
    const pageNumbers = paginationContainer.querySelector('.page-numbers');
    
    function updatePageNumbers(totalPages, currentPage) {
      pageNumbers.innerHTML = '';
      for (let i = 1; i <= totalPages; i++) {
        const pageButton = document.createElement('button');
        pageButton.classList.add('page-number');
        if (i === currentPage) {
          pageButton.classList.add('active');
        }
        pageButton.textContent = i;
        pageButton.addEventListener('click', () => {
          showPage(i);
          scrollToTop();
        });
        pageNumbers.appendChild(pageButton);
      }
    }

    function showPage(pageNum) {
      const state = tabStates.get(tabIndex);
      state.currentPage = pageNum;
      
      const filteredPosts = allPosts.filter(post => {
        const postYears = post.dataset.year.split(',');
        return state.currentYear === 'all' || postYears.includes(state.currentYear);
      });

      const startIndex = (pageNum - 1) * 10;
      const endIndex = startIndex + 10;
      
      // 隱藏所有，顯示當前頁面文章
      allPosts.forEach(post => post.style.display = 'none');
      
      const visiblePosts = filteredPosts.slice(startIndex, endIndex);
      visiblePosts.forEach(post => {
        post.style.display = 'flex';
      });

      // --- 執行對齊邏輯 ---
      // 使用 setTimeout 確保 DOM 渲染完成後再計算高度
      setTimeout(() => {
        alignPostTitles(visiblePosts);
      }, 50);
      // ------------------

      const totalPages = Math.ceil(filteredPosts.length / 10);
      updatePageNumbers(totalPages, pageNum);

      prevButton.style.display = pageNum > 1 ? 'block' : 'none';
      nextButton.style.display = pageNum < totalPages ? 'block' : 'none';
    }

    // 監聽視窗大小改變，重新計算對齊
    window.addEventListener('resize', function() {
       // 重新觸發當前頁面的顯示邏輯來校正高度
       // 這裡簡單抓取當前顯示的 posts 重新對齊
       const visiblePosts = Array.from(postContainer.querySelectorAll('.blog-post')).filter(p => p.style.display === 'flex');
       alignPostTitles(visiblePosts);
    });

    prevButton.addEventListener('click', () => {
      const state = tabStates.get(tabIndex);
      if (state.currentPage > 1) {
        showPage(state.currentPage - 1);
        scrollToTop();
      }
    });

    nextButton.addEventListener('click', () => {
      const state = tabStates.get(tabIndex);
      const filteredPosts = allPosts.filter(post => {
        const postYears = post.dataset.year.split(',');
        return state.currentYear === 'all' || postYears.includes(state.currentYear);
      });
      const totalPages = Math.ceil(filteredPosts.length / 10);
      if (state.currentPage < totalPages) {
        showPage(state.currentPage + 1);
        scrollToTop();
      }
    });

    const content = postContainer.closest('.blog-content');
    const yearList = content.querySelector('.blog-years-list');
    const yearSelect = content.querySelector('.blog-years-select');
    
    if (yearList) {
      yearList.querySelectorAll('li').forEach(yearItem => {
        yearItem.addEventListener('click', function() {
          const year = this.dataset.year;
          state.currentYear = year;
          
          yearList.querySelectorAll('li').forEach(li => li.classList.remove('active'));
          this.classList.add('active');
          
          if (yearSelect) {
            yearSelect.value = year;
          }
          
          showPage(1);
          scrollToTop(); // 篩選年份後回到頂部
        });
      });
    }
    
    if (yearSelect) {
      yearSelect.addEventListener('change', function() {
        const year = this.value;
        state.currentYear = year;
        
        if (yearList) {
          yearList.querySelectorAll('li').forEach(li => li.classList.remove('active'));
          const activeLi = yearList.querySelector(`li[data-year="${year}"]`);
          if (activeLi) {
            activeLi.classList.add('active');
          }
        }
        
        showPage(1);
        scrollToTop();
      });
    }

    showPage(1);
  }

  const tabs = document.querySelectorAll('.blog-tab');
  const contents = document.querySelectorAll('.blog-content');
  
  tabs.forEach((tab, tabIndex) => {
    tab.addEventListener('click', function() {
      const tabId = this.dataset.tabId;
      activateTab(tabIndex);
      if (tabId) updateUrlHash(tabId);
      setTimeout(() => scrollToTop(), 100);
    });
  });

  contents.forEach((content, index) => {
    const postContainer = content.querySelector('.blog-posts');
    setupPagination(postContainer, index + 1);
  });

  window.addEventListener('hashchange', showTabByHash);
  showTabByHash();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
